import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IonIcon } from '@ionic/react';
import { keyOutline, createOutline, trashOutline, copyOutline } from 'ionicons/icons';
import DataTable from '../../components/shared/DataTable/DataTable';
import { SkeletonTable } from '../../components/atoms';

const ProjectsList = ({ 
  projects = [], 
  loading = false, 
  onEdit, 
  onDelete,
  onCopyApiKey,
  onAdd
}) => {
  const navigate = useNavigate();

  const maskToken = (token) => {
    if (!token) return '—';
    const prefix = token.substring(0, 4);
    const suffix = token.substring(token.length - 4);
    return `${prefix}...${suffix}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const columns = [
    {
      header: 'Name',
      key: 'name',
      className: 'data-table-name',
      render: (project) => project.name
    },
    {
      header: 'Token',
      key: 'apiToken',
      className: 'data-table-token',
      render: (project) => (
        <span
          className="token-copyable"
          title="Click to copy"
          onClick={(e) => {
            e.stopPropagation();
            onCopyApiKey(project);
          }}
        >
          <span className="token-text">{maskToken(project.apiToken)}</span>
          <IonIcon icon={copyOutline} className="token-copy-icon" />
        </span>
      )
    },
    {
      header: 'Created',
      key: 'createdAt',
      className: 'data-table-date',
      render: (project) => formatDate(project.createdAt)
    }
  ];

  const actions = [
    {
      label: 'Copy API Key',
      icon: keyOutline,
      onClick: onCopyApiKey
    },
    {
      label: 'Edit',
      icon: createOutline,
      onClick: onEdit
    },
    {
      divider: true
    },
    {
      label: 'Delete',
      icon: trashOutline,
      onClick: onDelete,
      danger: true
    }
  ];

  if (loading) {
    return (
      <SkeletonTable
        columns={[
          { headerWidth: '60px', width: '180px', height: '14px' },
          { headerWidth: '80px', width: '140px', height: '14px' },
          { headerWidth: '70px', width: '90px', height: '14px' },
          { thWidth: '40px', width: '24px', height: '24px', borderRadius: '50%' }
        ]}
        rowCount={5}
        label="Loading"
      />
    );
  }

  return (
    <DataTable
      data={projects}
      columns={columns}
      loading={loading}
      rowKey="projectId"
      onRowClick={(project) => navigate(`/projects/${project.projectId}/pipelines`)}
      actions={actions}
      emptyState={{
        title: "No Projects Yet",
        description: "Create your first project to get started.",
        actionLabel: "Add",
        onAction: onAdd
      }}
    />
  );
};

export default ProjectsList;
